import { render, staticRenderFns } from "./StudentTimeline.vue?vue&type=template&id=015f8217&"
import script from "./StudentTimeline.vue?vue&type=script&lang=js&"
export * from "./StudentTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports